var React = require('react');

function CircleInsideHexagon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(3 2.215)","stroke":"#EEAA85","strokeWidth":"4.68","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M73.138 30.613L54.21 60.493a.36.36 0 01-.304.167H19.59a.36.36 0 01-.304-.167L.303 30.613a.36.36 0 010-.386L19.287.347a.36.36 0 01.304-.167h34.315a.36.36 0 01.304.167l18.928 29.88a.36.36 0 010 .386z","key":0}),React.createElement("circle",{"cx":"36.18","cy":"29.34","r":"12.24","key":1})]));
}

CircleInsideHexagon.defaultProps = {"width":"79","height":"66"};

module.exports = CircleInsideHexagon;

CircleInsideHexagon.default = CircleInsideHexagon;
